import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    // {
    //   path: '*',
    //   redirect: '/index/:pid'
    // },
    {
      path: '/index/:pk/:did',
      name: 'index',
      component: Index,
      meta: {
        title: '\u200E',
        index: 1,
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js